module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d7e193724"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c5_r1#d6e3",
      "id": "d7e3"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")])]), _c('br'), _c('br'), _c('b', [_vm._v("Freedom ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e194524"
    }
  }, [_vm._v("The God who gave us life, gave us liberty at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e195224"
    }
  }, [_vm._v("—Thomas Jefferson")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e195724"
    }
  }, [_c('b', [_vm._v("Freedom ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e196224"
    }
  }, [_vm._v("Throughout world history people have been oppressed, be it through slavery, by the state, by their sovereign or any number of entities that sought and succeeded to obtain and maintain power. From the start, America was different. While conquistadors first set foot in the Americas seeking only plunder, the first settlers, those who uprooted their lives and families to move here permanently, did so in the hope of escaping oppression of one form or another. Although they did not always live up to the lofty goals they set for themselves, they certainly planted the seed from which the tree of liberty grew.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199824"
    }
  }, [_vm._v("President Abraham Lincoln opened the Gettysburg Address this way: “Four score and seven years ago our fathers brought forth, upon this continent, a new nation, conceived in liberty, and dedicated to the proposition that ‘all men are created equal.’” “Conceived in liberty.” The irony and tragedy of slavery are not lost on us, but viewing history through the eyes of today cheapens the momentous achievements of a nation that, while not perfect, is ever striving toward the “more perfect Union” referenced in the preamble of the Constitution. Perfection is impossible to achieve; striving for it inspires greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e204025"
    }
  }, [_vm._v("Ever since its founding, the United States has been, in the words of the late senator Daniel P. Moynihan (D-NY), the “party of liberty.” The liberty we enjoy, that many of us take for granted and that oppressed masses around the world desperately seek, is part of our national DNA. It is the freedom to decide what to do with your life, how to live it, what career to pursue, what to think, and what to say. While anything but those options feels foreign to us, and the concept of not having those basic rights may be difficult, if not impossible, for us to imagine, they were simply concepts—abstract and interesting ideas—until the United States came into being.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e207925"
    }
  }, [_vm._v("The Magna Carta, written in 1215, first put limits on the power of a king and was an important precursor to our Constitution, but it was mainly a document that nobles forced King John of England to sign in order to protect their personal rights, not the rights of all men.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e209825"
    }
  }, [_vm._v("When our Constitution was ratified in 1789, for the first time in human history individual, God-given rights and a limited government went from concept to reality. “Liberty must at all hazards be supported. We have a right to it, derived from our Maker. But if we had not, our fathers have earned and bought it for us, at the expense of their ease, their estates, their pleasure, and their blood,” John Adams declared."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d11",
      "id": "a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e213126"
    }
  }, [_c('b', [_vm._v("Misconceptions About American Rights ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e213626"
    }
  }, [_vm._v("The Constitution protects our God-given rights from government; the government does not grant those rights to us as citizens. This is perhaps the most widely misunderstood aspect of our system of government.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e215226"
    }
  }, [_vm._v("That the power of government is derived from the consent of the governed was first articulated by John Locke in his 1690 "), _c('i', [_vm._v("Second Treatise of Government ")]), _vm._v("when he wrote, “Men being, as has been said, by nature, all free, equal, and independent, no one can be put out of this estate, and subjected to the political power of another, without his own consent.” Locke’s words are the underlying basis of the First Amendment in the Bill of Rights, which reads: “Congress shall make no law respecting an establishment of religion, or prohibiting the free exercise thereof; or abridging the freedom of speech, or of the press; or the right of the people peaceably to assemble, and to petition the Government for a redress of grievances.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e219626"
    }
  }, [_vm._v("To hear a lot of people talk about it, they reference their First Amendment right to free speech as though the First Amendment grants them the right to say what they like. That is looking at it the wrong way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e221326"
    }
  }, [_vm._v("Were the Constitution the granter of the right to free speech, religion, assembly, and so forth, the First Amendment would not start out, “Congress shall make no law.” That part of the sentence clearly states that the government has no rightful authority over those things and is blocked from infringing upon them. This is the concept of negative rights.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e224027"
    }
  }, [_vm._v("A negative right is one that cannot be infringed upon by outside forces. Government is not granting you the right to free speech; it is expressly forbidden from attempting to infringe on it. While the saying “my constitutional right to free speech” may seem harmless, it points to a larger misunderstanding of where our rights come from.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e226527"
    }
  }, [_vm._v("The Declaration of Independence asserts that all men “are endowed by their Creator with certain unalienable Rights.” In other words, our rights to “Life, Liberty, and the Pursuit of Happiness” are God given, not government given. But if you believe that we are granted our fundamental rights by the government, then you are more likely to seek additional favors from the government. If the government is the granter of all good things, what is to stop someone from thinking up more good things that could and should be granted by government?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e229527"
    }
  }, [_vm._v("Yet our government is not Santa Claus writ large, and our rights are not wish lists drawn up by eager tots on Christmas Eve. Any fair-minded reading of the Constitution reveals that it does not grant us the wonderful rights we embrace; it handcuffs the government from infringing upon them. Or at least, it used to be that way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e231827"
    }
  }, [_vm._v("Nowhere do modern conservatives and liberals diverge more than on the reading of the Constitution and, therefore, on the origin of our most precious rights. Liberals view the Constitution as a living document that can have read into it nearly anything based on the political fashions of the day, so it is not surprising that someone like Senator Bernie Sanders (I-VT)—a self-described socialist—would pen a piece for the liberal "), _c('i', [_vm._v("Huffington Post ")]), _vm._v("titled “Health Care Is a Right, Not a Privilege.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e235528"
    }
  }, [_vm._v("Senator Sanders might be dismayed to learn that the totalitarian rulers of the former Soviet Union fully shared his commitment to health care as a fundamental right. Indeed, the Soviet Constitution guaranteed Soviet citizens the right to health care as well as a host of other rights—including the rights to labor, rest, material security in old age, housing, and education. For example: “USSR citizens have the right to labor—that is, to receive guaranteed work and remuneration for labor in accordance with its quantity and quality and not below the minimum amount established by the state. . . . This right is ensured by the socialist economic system, [and] the steady growth of productive forces.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d12",
      "id": "a12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e239928"
    }
  }, [_vm._v("Of course, the Soviet Constitution could guarantee a job to every citizen because the state controlled the entire economy. There was no private sector. As long as you were a loyal Soviet citizen, the state would make sure that you had some sort of job, however poorly paid. But the moment you stepped out of line and criticized the state in any way, you would lose your state-run job, you would be hauled before a state-run court, and you would be sentenced to a state-run jail, a state-run mental home, or a state-run labor camp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e243328"
    }
  }, [_vm._v("By contrast, although the media often refer to the president of the United States as the most powerful man in the world, in reality he lacks the power to tell even the smallest business owner whom to hire or fire. Admittedly our system has its drawbacks. Wouldn’t it be convenient, for example, if an unemployed American could simply call up a government bureaucrat and demand to be provided with his constitutionally guaranteed right to a job? On the other hand, because the government does not control the private sector in the United States, you and I are free to denounce the government on Monday, to demonstrate against government policy on Tuesday, to write an angry letter to the editor and post a blistering antigovernment blog on Wednesday, and not have to worry about losing our jobs on Thursday, appearing before a judge on Friday, and going to jail on Saturday.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e248829"
    }
  }, [_vm._v("Similarly, if the US government recognized a right to health care, it would be necessary for it to take control of the healthcare industry, roughly 17 percent of our gross domestic product. How else could it enforce this right? Yet obtaining control of such a large slice of our economy would increase the powers of the state enormously and would pose a clear and present danger to our liberty. Indeed, the threat to American liberty posed by ObamaCare (a.k.a. the Patient Protection and Affordable Care Act) has led millions of heretofore politically uninvolved Americans to join the grassroots Tea Party movement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e252629"
    }
  }, [_vm._v("The Tea Partiers’ objections to ObamaCare are absolutely justified. By centralizing health-care decisions in Washington, ObamaCare places the federal government in charge of our most intensely personal matters: our own health care and the health care of our loved ones. Heritage scholar Robert Moffit has observed:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e254929"
    }
  }, [_vm._v("Americans face a direct and historic challenge to their personal liberty and to their unique citizenship in a federal republic. Through its enactment of the massive Patient Protection and Affordable Care Act, official Washington is not merely engineering a federal takeover of health care, but it is also radically altering the relationships between individuals and the government as well as the national government and the states."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d13",
      "id": "a13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258530"
    }
  }, [_vm._v("This is why conservatives steer clear of calling health care a right (implying greater government control in order to secure that right). Instead, we call for reforms that meet the health-care needs of both insured and uninsured Americans through greater reliance on the free market and the private sector. Conservatives also look to the states (which have already emerged as centers of resistance to the unprecedented concentration of political and economic power in Washington that is the essence of ObamaCare) to pursue high-quality, innovative health care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e262030"
    }
  }, [_vm._v("Our Founding Fathers did not see government as a benevolent Santa Claus guaranteeing an ever-expanding wish list of rights; rather, they viewed government as a necessary evil—far preferable to anarchy, but nonetheless a serious threat to liberty. Liberty was the ultimate goal of our Founders, and for its sake they were willing to lay down their lives. In the famous words of Patrick Henry: “Is life so dear or peace so sweet as to be purchased at the price of chains and slavery? Forbid it, Almighty God! I know not what course others may take, but as for me, give me liberty, or give me death!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d14",
      "id": "a14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e266030"
    }
  }, [_vm._v("Patrick Henry’s spirit—the American Spirit—continues to inspire oppressed peoples around the world. While the vicious dictatorship in Iran, for example, has remained steadfastly anti-American, the Iranian people themselves have warmed to the United States. This affection was not lost on that bastion of liberal media, the "), _c('i', [_vm._v("Washington Post")]), _vm._v(", which ran a story in 2008 titled “Stars (and Stripes) in Their Eyes.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d15",
      "id": "a15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" In it journalist Azadeh Moaveni recounts her shock at how average Iranian citizens reject their government’s characterization of our way of life:")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e270631"
    }
  }, [_vm._v("Although their leaders still call America the “Great Satan,” ordinary Iranians’ affection for the United States seems to be thriving these days, at least in the bustling capital. This rekindled regard is evident in people’s conversations, their insatiable demand for U.S. products and culture, and their fascination with the U.S. presidential campaign. One can’t do reliable polling about Iranians’ views under their theocratic government, of course, but these shifts were still striking to me as a longtime visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e274031"
    }
  }, [_vm._v("That freedom and liberty seep into even the most oppressive regimes will come as no surprise to students of recent history. When the people of Eastern Europe rose up and regained their freedom and independence in 1989, the example of the United States inspired them. The masses embraced a democratic-capitalist system they had never known, embodied by what their government told them was the enemy of all peace-loving people—the United States. Our nation symbolized liberty to people who had never visited the United States and who were fed a daily diet of lies about us through government-controlled media. But liberty, like water, somehow finds a way.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e278832"
    }
  }, [_c('b', [_vm._v("Individual Liberty Under Siege ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e279332"
    }
  }, [_vm._v("While the world’s oppressed peoples have fought to move toward liberty and freedom, there are those in the United States who seek to deny it to their fellow citizens. Ironically they use freedom to undermine freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e280932"
    }
  }, [_vm._v("Consider, for example, calls by the radical Left for the reinstatement of the so-called Fairness Doctrine. The Fairness Doctrine is an affront to freedom of speech. It requires radio and television stations to give equal time to opposing viewpoints, meaning that every hour of Rush Limbaugh must be countered with an hour devoted to the liberal viewpoint. The only problem is that Rush Limbaugh is wildly popular on radio, while the sum total of all liberal radio talk shows reaches only a fraction of his audience. Since radio (with the exception of National Public Radio) is a business, a profit must be made, and the only way to make it is by attracting as large an audience as possible. Conservatives are extremely popular on radio. Progressives, despite many attempts and hundreds of millions of dollars, have not been able to break into radio in any meaningful way, so they seek to destroy talk radio instead. By denying stations hosting talk radio a profit, the Fairness Doctrine would accomplish precisely that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e286932"
    }
  }, [_vm._v("But simply having the Federal Communications Commission reinstate the Fairness Doctrine without an understandable reason would expose these anti–free speech advocates for what they are—enemies of freedom—so a campaign of demonization is needed to justify their efforts. The radical community organizer Saul Alinsky, in his handbook for left-wing extremists, "), _c('i', [_vm._v(" Rules for Radicals")]), _vm._v(", laid out the framework for how modern leftists should attack their opponents, particularly in Rule 13: pick the target, freeze it, personalize it, and polarize it.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e290833"
    }
  }, [_vm._v("The accusations of racism against Rush Limbaugh, Sean Hannity, Mark Levin, Glenn Beck, and all other top-rated radio talk show hosts are as unfounded as they are unrelenting, but the Left’s campaign of defamation is taken right out of Alinsky’s playbook. By portraying conservative opponents as purveyors of hate speech, the Left seeks to limit their rights and the rights of the stations that carry their programs. Thus far, their campaign has been little more than a nuisance, but progressives are persistent. Their ultimate goal is to delegitimize all viewpoints except their own. Liberty, taken for granted by Americans, provides fertile ground for those seeking to eliminate it.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e294733"
    }
  }, [_c('b', [_vm._v("Personal Freedom and Economic Freedom ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e295233"
    }
  }, [_vm._v("The freest societies throughout history have always been the most prosperous. The more freedom that people have to engage in entrepreneurial and other economic activities, the more products, processes, innovation, jobs, wealth, and opportunity will be created. History has shown that only in times of economic turmoil have the forces opposed to individual liberty been able to fully seize power. No revolution has overthrown a government in times of widely shared prosperity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e298133"
    }
  }, [_vm._v("In the United States, the ten states noted for the greatest amount of freedom, opportunity, and encouragement of business activity are also the fastest-growing and most prosperous states. On the other hand, the states with the greatest burden of taxes, regulations, and restriction on businesses are the ten slowest-growing states.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e300834"
    }
  }, [_vm._v("The link between freedom and prosperity also holds true on the world’s stage. For eighteen years now, the Heritage Foundation has produced the annual "), _c('i', [_vm._v("Index of Economic Freedom ")]), _vm._v("in cooperation with the editors of the "), _c('i', [_vm._v("Wall Street Journal")]), _vm._v(". Each year, the "), _c('i', [_vm._v("Index ")]), _vm._v("ranks 179 nations in terms of their levels of economic freedom, characterizing them as “free,” “mostly free,” “moderately free,” “mostly unfree,” and “repressed.” During this entire period, Hong Kong has always been ranked number one in the "), _c('i', [_vm._v("Index")]), _vm._v(", thanks to its small government, low taxes, and light regulation. As former attorney general Edwin Meese—now a Distinguished Fellow at the Heritage Foundation—put it in a Heritage lecture, “Economic freedom and economic prosperity rise and fall together.” Attorney General Meese cited the remarkable history of Hong Kong as a brilliant illustration of the value of political and economic freedom:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e307634"
    }
  }, [_vm._v("A century and a half ago, Britain’s Lord Palmerston dismissed Hong Kong as “a barren rock with hardly a house upon it.” One can only wonder what Lord Palmerston might think if he could visit Hong Kong today.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e309434"
    }
  }, [_vm._v("For he would walk among skyscrapers that hold the offices of nine thousand multinational companies. His eyes would behold the fifth-largest banking center on earth, and the eighth-largest stock market. He would stroll among citizens who earn the sixth-highest per capita income in the world. He would see a conduit through which flows 70 percent of all foreign investment in China. And he would no doubt be dumbstruck to see all this dynamic economic energy being generated on an island with a population smaller than that of Chicago.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e313635"
    }
  }, [_vm._v("Hong Kong’s metamorphosis is all the more striking when you consider that it enjoys none of the natural resources that enabled other nations to become economic giants—no mighty rivers, no vast tracts of timber, no rich veins of ore and minerals. Yet, despite such handicaps, what Lord Palmerston called a “barren rock” is today the Pearl of the Orient—and a gleaming demonstration of the power and value of economic freedom."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d16",
      "id": "a16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e316735"
    }
  }, [_vm._v("By contrast, nations like the United Kingdom and (alas!) the United States—once admired throughout the world for their commitment to economic freedom—have recently seen a sharp decline in their "), _c('i', [_vm._v("Index ")]), _vm._v("ratings. The director of Heritage’s Center for International Trade and Economics, Ambassador Terry Miller, has noted:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e319635"
    }
  }, [_vm._v("For the U.S. and the U.K., the "), _c('i', [_vm._v("Index of Economic Freedom ")]), _vm._v("confirms what those countries’ voters already knew, that there is an urgent need for real change. The U.S. dropped to 9th place in the 2011 "), _c('i', [_vm._v("Index")]), _vm._v(", and the U.K. fell all the way to 16th place.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e322235"
    }
  }, [_vm._v("Those who feel we are losing economic vitality and leadership to Asia have cause for concern. Hong Kong, Singapore, Australia and New Zealand dominate the top of the economic freedom rankings. Economic growth rates in those countries averaged 6.8 percent in 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e324436"
    }
  }, [_vm._v(". . . Politicians around the world are getting the message, or they are being replaced. The proven path to prosperity is the path of freedom. Individuals want control of their own lives. They want governments that facilitate, not czars that coerce or command. Fortunately, the process of reclaiming our economic freedom has already begun. Our economic recovery depends on its rapid success."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d17",
      "id": "a17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e327236"
    }
  }, [_vm._v("It is important to note that the 2012 "), _c('i', [_vm._v("Index of Economic Freedom ")]), _vm._v("by the Heritage Foundation found little changed in the top of the list. The same four countries reside there along with newcomer Switzerland. The entire list can be found at "), _c('a', {
    attrs: {
      "href": "http://www.Heritage.org",
      "id": "d14e746",
      "target": "_blank"
    }
  }, [_vm._v("www.Heritage.org")]), _vm._v(". Ambassador Miller’s commentary on the findings of the "), _c('i', [_vm._v("Index of Economic Freedom ")]), _vm._v("reinforces the eloquent words with which Attorney General Meese concluded his 1999 Heritage lecture: “To attain freedom is mankind’s highest aspiration. To use freedom wisely is mankind’s urgent responsibility. To preserve freedom is mankind’s continuing challenge. May we all be equal to that task.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d18",
      "id": "a18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5921baa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feul_9781595553904_epub_c8_r1.vue
// module id = 78
// module chunks = 0